import {EditorState, Transaction} from "prosemirror-state";
import {EditorView} from "prosemirror-view";

import type {TableContextMenuParams} from "../../../../ui/elements/context-menu/editor/TableToolbar/openTableContextMenu";

import {insertRow} from "./insertRow";
import {getNearestCellPos} from "../../../utils/table/getNearestCellPos";
import {isPosInTable} from "../../../utils/table/isPosInTable";
import {getInTableRect} from "../../../utils/table/getInTableRect";

export const insertRowUp = (state: EditorState, dispatch?: (tr: Transaction) => void, view?: EditorView, params?: TableContextMenuParams): boolean => {
    let targetPos = state.selection.$from.pos;
    if (params?.clickPos) {
        targetPos = params.clickPos;
    }
    const $pos = getNearestCellPos(state.doc.resolve(targetPos));
    if (!$pos || !isPosInTable($pos)) {
        return false;
    }

    if (dispatch) {
        const tableRect = getInTableRect($pos);
        const diff = tableRect.bottom - tableRect.top;
        dispatch(insertRow(state.tr, tableRect, tableRect.top, diff))
    }
    return true
}
